import { Component } from '@angular/core';
import { AuthData, AuthenticationService } from "@/core/services/authentication.service";
import { LoginAsAdminInput, LoginGQL } from "@/core/graphql/graphql";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { MatDialogRef } from "@angular/material/dialog";


@Component({
  selector: 'cosmos-credential-modal',
  templateUrl: './credential-modal.component.html',
  styleUrls: ['./credential-modal.component.scss'],
})
export class CredentialModalComponent {
  public _credentialForm = new FormGroup({
    userId: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  })

  public constructor(
    private readonly _authenticationService: AuthenticationService,
    private readonly _loginGql: LoginGQL,
    private _modalRef: MatDialogRef<CredentialModalComponent>,
  ) { }

  public verifyCredentials(): void {
    if (this._credentialForm.invalid) {
      return;
    }
    const formValues = this._credentialForm.value;

    const input: LoginAsAdminInput = {
      identifier: formValues.identifier,
      password: formValues.password,
    };

    this._loginGql.mutate(
      { input },
      { errorPolicy: 'all' }).pipe(first()).subscribe(
      value => {
        this._modalRef.close(true);
      },
      () => {
        this._modalRef.close(false);
      },
    );
  }

  public closeModal(): void {
    this._modalRef.close();
  }
}
